import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";

import { ShortcutCategoryService } from "src/app/core/core-services/services/shortcut-category.service";
import { LoadingService } from "src/app/components/loading/loading.service";

@Injectable()
export class ShortcutCategoryListResolver  {
  constructor(private shortcutCategoryService: ShortcutCategoryService, private loadingService: LoadingService) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): void {
    // this.loadingService.show();
    this.shortcutCategoryService.loadShortcutCategory({ reloadFromApi: false }, () => {
      // this.loadingService.hide();
    });
  }
}
